import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2
} from '@angular/core';
import { SetPositionTooltipDirectiveService } from './setposition-tooltip.service';
import { TooltipDirectiveService } from './tooltip.service';

@Directive({
  selector: '[idpTooltip]'
})
export class TooltipDirective {
  @Input()
  tooltipContent!: string;

  @Input() tooltipPosition: string | undefined;
  @Input() tooltipDelay = 500;
  @Input() tooltipClick = false;
  @Input() tooltipHover = true;
  @Input() tooltipRole = false;
  tooltip!: HTMLElement | null;
  offset = 8;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private tooltipDirectiveService: TooltipDirectiveService,
    private setPositionService: SetPositionTooltipDirectiveService
  ) {}

  @HostListener('click') onMouseClick() {
    if (!this.tooltip && this.tooltipClick) {
      this.show();
    }
  }

  @HostListener('focusout') onFocusOut() {
    if (this.tooltip) {
      this.hide();
    }
  }

  @HostListener('mouseenter') onMouseEnter() {
    if (!this.tooltip && !this.tooltipClick && this.tooltipHover) {
      this.show();
    }
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.onClose();
  }

  onClose() {
    if (this.tooltip && !this.tooltipClick && this.tooltipHover) {
      this.hide();
    }
  }

  show() {
    this.create();
    this.setPosition();
    this.renderer.addClass(this.tooltip, 'idp-tooltip-show');
  }

  hide() {
    this.renderer.removeClass(this.tooltip, 'idp-tooltip-show');
    window.setTimeout(() => {
      this.renderer.removeChild(document.body, this.tooltip);
      this.tooltip = null;
    }, this.tooltipDelay);
  }

  create() {
    this.tooltip = this.renderer.createElement('span');

    this.createCloseButton();

    this.renderer.appendChild(
      this.tooltip,
      this.renderer.createText(this.tooltipContent)
    );

    this.renderer.appendChild(document.body, this.tooltip);

    if (this.tooltipRole) {
      this.renderer.setAttribute(this.tooltip, 'role', 'alert');
    }
    this.renderer.addClass(this.tooltip, 'idp-tooltip');
    this.renderer.addClass(this.tooltip, '__content');
    this.renderer.addClass(this.tooltip, `idp-tooltip-${this.tooltipPosition}`);

    this.tooltipDirectiveService.setstylefunction(
      this.renderer,
      this.tooltip,
      this.tooltipDelay
    );
  }

  createCloseButton() {
    const closeButton = this.renderer.createElement('button');
    const iconButton = this.renderer.createElement('i');

    this.tooltipDirectiveService.createCloseBtnFun(
      closeButton,
      iconButton,
      this.renderer
    );
    this.renderer.listen(closeButton, 'click', () => {
      this.hide();
    });

    this.renderer.appendChild(closeButton, iconButton);
    this.renderer.appendChild(this.tooltip, closeButton);
  }

  async setPosition() {
    const hostPos = this.el.nativeElement.getBoundingClientRect();

    const tooltipPos = this.tooltip
      ? this.tooltip.getBoundingClientRect()
      : { height: 0, width: 0 };

    const scrollPos = await this.tooltipDirectiveService.GetWindowValue();

    const topLeftPayload = {
      tooltipPosition: this.tooltipPosition,
      hostPos: hostPos,
      tooltipPos: tooltipPos,
      offset: this.offset,
      tooltip: this.tooltip,
      scrollPos: scrollPos,
      renderer: this.renderer
    };
    this.setPositionService.getTopLeftValue1(topLeftPayload);

    this.setPositionService.getTopLeftValue2(topLeftPayload);

    this.setPositionService.getTopLeftValue3(topLeftPayload);

    this.setPositionService.getTopLeftValue4(topLeftPayload);

    this.tooltipDirectiveService.getTopLeftValue5(topLeftPayload);
  }
}
